
export const SET_DSR_FAQ_CONTENT = 'set_dsr_faq_content';

export const GET_DSR_FAQ_CONTENT_REQUEST = 'get_dsr_faq_content_request';
export const GET_DSR_FAQ_CONTENT_SUCCESS = 'get_dsr_faq_content_success';
export const GET_DSR_FAQ_CONTENT_FAILURE = 'get_dsr_faq_content_failure';

export const MANAGE_DSR_FAQ_CONTENT_REQUEST = 'manage_dsr_faq_content_request';
export const MANAGE_DSR_FAQ_CONTENT_SUCCESS = 'manage_dsr_faq_content_success';
export const MANAGE_DSR_FAQ_CONTENT_FAILURE = 'manage_dsr_faq_content_failure';
export const RESET_MANAGE_DSR_FAQ_CONTENT = 'reset_manage_dsr_faq_content';